module.exports = __webpack_public_path__ + "static/media/premium-success.4ff74f8c.svg";